import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const productSchema = new schema.Entity('products');

export const products = configureApiEntity('PROODUCTS', 'products', productSchema);
